<template>
  <div class="version-badge" :title="tooltipText">
    <span class="version-label">v</span>{{ version }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const version = __APP_VERSION__;
const buildTime = __BUILD_TIME__;

const tooltipText = computed(() => {
  const date = new Date(buildTime);
  const formattedDate = date.toLocaleString();
  return `Version ${version}\nBuilt: ${formattedDate}`;
});
</script>

<style scoped>
.version-badge {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: #00ff88;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 0.75em;
  font-family: 'Courier New', monospace;
  border: 1px solid rgba(0, 255, 136, 0.3);
  cursor: help;
  z-index: 9999;
  transition: all 0.3s ease;
  user-select: none;
}

.version-badge:hover {
  background: rgba(0, 255, 136, 0.2);
  border-color: #00ff88;
  transform: scale(1.05);
}

.version-label {
  opacity: 0.7;
  margin-right: 2px;
}

@media (max-width: 768px) {
  .version-badge {
    bottom: 5px;
    right: 5px;
    font-size: 0.65em;
    padding: 4px 8px;
  }
}
</style>
